import {
    FieldPiecesPlugin,
    BallsPlugin,
    PlayersPlugin,
    ShotsPlugin,
    AssignmentsPlugin,
    FieldCommentsPlugin,
    SnapLinesPlugin,
} from '../plugins/index.js';

import FormationPlugin from './plugins/formation.js';
import MovementsPlugin from './plugins/movements.js';
import OptionsPlugin from './plugins/options.js';
import PassesPlugin from './plugins/passes.js';
import RouteOptionsPlugin from './plugins/route-options.js';
import ShadingPlugin from './plugins/shading.js';

export default [
    FieldPiecesPlugin,
    BallsPlugin,
    PlayersPlugin,
    MovementsPlugin,
    PassesPlugin,
    ShotsPlugin,
    OptionsPlugin,
    RouteOptionsPlugin,
    AssignmentsPlugin,
    ShadingPlugin,
    FieldCommentsPlugin,
    SnapLinesPlugin,
    FormationPlugin,
];
